export const SALES_WIDGET_ENDPOINT = "/sales-api/workspace-data";
export const ANALYSIS_ENDPOINT = `/sales-api/site-analysis`;
export const API_ANALYSIS_ENDPOINT = `/sales-api/site-analysis`;
